import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isAuthEnabled, loginRequest } from '@/auth/authConfig';
import { paths } from '@/routes/paths';
import pathwayLogo from '@/assets/images/pathway-logo.png';

export function UnauthorizedPage() {
  const [logoError, setLogoError] = useState(false);
  const navigate = useNavigate();
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const authEnabled = isAuthEnabled();
  const showLoginButton = authEnabled && !isAuthenticated;

  const handleClick = () => {
    if (showLoginButton) {
      // Redirect directly to Azure AD login
      instance.loginRedirect(loginRequest);
    } else {
      navigate(paths.dashboard);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        px: 2,
      }}
    >
      {logoError ? (
        <Typography variant="h5" component="span" sx={{ mb: 2 }}>
          OC&C Pathway
        </Typography>
      ) : (
        <Box
          component="img"
          src={pathwayLogo}
          alt="OC&C Pathway"
          sx={{ maxHeight: 120, mb: 2 }}
          onError={() => setLogoError(true)}
        />
      )}
      <Typography variant="h4" component="h1">
        Page unavailable
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        This area is restricted or no longer available.
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={handleClick}
      >
        {showLoginButton ? 'Go to Login Page' : 'Go to Dashboard'}
      </Button>
    </Box>
  );
}

export default UnauthorizedPage;
